export enum BiteLogMonerisEvent {
  None = 0,
  TerminalConnected = 1,
  TerminalDisconnected = 2,
  SaleTransactionRequested = 3,
  SaleTransaction = 4,
  SaleTransactionError = 5,
  DeviceSetup = 6,
  DeviceSetupError = 7,
  RefundTransactionRequested = 8,
  RefundTransaction = 9,
  RefundTransactionError = 10,
  Logs = 11,
  TerminalUnresponsiveError = 12,
  TerminalRebootRequested = 13,
  TerminalRebootSkipped = 14, // transaction in flight
}
